import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductChangeRequestsPage } from "src/components/views/erp/productChanges/requests/ProductChangeRequestsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/productManagement/productChangeRequests")({
	staticData: { title: i18n.t("product_change_requests"), legacyViewKey: "productChangeRequestsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProductChangeRequestsPage />;
}
